import Navbar from "./Navbar";
import Footer from "./Footer";
import GlobalAudioPlayer from "./GlobalAudioPlayer";

export default function Layout({ children, showFooter = true }) {
  return (
    <div className="App flex flex-col min-h-screen">
      <Navbar />
      <main className="flex-1">{children}</main>
      {showFooter && <Footer />}
      <GlobalAudioPlayer />
      <div className="h-20" />
    </div>
  );
}
